module.exports = __webpack_public_path__ + "fonts/acc89c2c/proximanova-boldit-webfont.woff";